import { Injectable } from "@angular/core";
import { HelperService } from "../shared/services/helper.service";
import { environment } from "../../environments/environment";
import { HttpService } from "../shared/services/http.service";
import { HttpParams } from "@angular/common/http";
import { UserApplicationViewModel } from "../models/application.user.model";

@Injectable()
export class ApplicationUserService {

  private BASE_URL: string = HelperService.buildRequestURL(environment.RipleyApplicationUserAdminApiEndPoint);
  private REQUEST_URL: string = `${this.BASE_URL}`;
  private URL: string;

  constructor(private httpService: HttpService) { }

  public GetUserLoginMSA(filter: any) {
    let httpParams = new HttpParams({
      fromObject: filter
    });
    this.URL = `${this.REQUEST_URL}/modules`;
    return this.httpService.get<UserApplicationViewModel>(this.URL, { params: httpParams });
  }

}
